export default __webpack_public_path__ + "static/media/portrait_mode_alert_bg.1b1cbf2e.png";